import Bridge from './bridge';

class UnityChallengesActions {
    constructor () {
        this._initialize();
    }

    _initialize () {
        console.debug('[UnityChallengesActions._initialize] Initialized');
    }

    sendViewChallengeMessage (challenge) {
        console.debug('[UnityChallengesActions.sendViewChallengeMessage] Sending challenge to Unity', challenge);
        Bridge.sendMessage('ViewChallenge', challenge);
    }

    sendArcadeMessage (challenge) {
        console.debug('[UnityChallengesActions.sendArcadeMessage] Sending arcade message to Unity', challenge);
        Bridge.sendMessage('Arcade', challenge);
    }
}

export default UnityChallengesActions;
